import 'bxslider'

export default {
  init() {
    // JavaScript to be fired on the home page
    $(window).load(function () {
      $('.bxslider').bxSlider({
        mode: 'vertical',
        auto: true,
        speed: 600,
        pause: 4200,
        pager: false,
        controls: false,
        startSlide: 0,
      });
      $('.flexslider').flexslider({
        animation: "slide",
        directionNav: false,
      });
      $('.slick-carousel').slick({
        autoplay: true,
        arrows: true,
        prevArrow: '<div class="slick-arrow-prev"></div>',
        nextArrow: '<div class="slick-arrow-next"></div>',
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    if ($(window).width() > 991) {

      // waypoints
      $('.fadein').each(function () {
        let activeElem = $(this);
        activeElem.waypoint(function () {
          activeElem.addClass('visibled');
        }, {
          offset: '95%',
        });
      });
    } else {
      // waypoints
      $('.fadein').each(function () {
        $(this).addClass('visibled');
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js